import { UPDATE_STORE_STAT_WIDGET } from "./actionTypes"

export const updateStoreStatWidget = data => {
  return {
    type: UPDATE_STORE_STAT_WIDGET,
    payload: data,
  }
}
